import appUserVerifications from "../../views/appSettings/userVerifications.html";
import constants from "../../core/constants";
import { getState } from "../../core/utils";

function urlsConfig($stateProvider) {
  "ngInject";

  const base = "users/verify";
  const params = ["page", "limit"];

  $stateProvider.state("userverifications", {
    url: getState(base, params),
    parent: "app",
    views: {
      view: {
        template: appUserVerifications,
      },
    },
    reloadOnSearch: false,
    data: { title: "User Verifications" + constants.titleBase },
  });
}

export default urlsConfig;



// WEBPACK FOOTER //
// ./src/pages/userVerifications/userVerifications.urls.js